import React from 'react';
import { User, Briefcase, FileText, DollarSign, Users, CalendarDays, Mic, Clock, Inbox, BookOpen } from 'lucide-react';

export default function SideNav({ active, setActive }) {
  const items = [
    { key: 'profile', label: 'My Profile', icon: User },
    { key: 'workspace', label: 'Workspace', icon: Inbox },
    { key: 'my-campaigns', label: 'My Campaigns', icon: Briefcase },
    { key: 'campaigns', label: 'Browse Campaigns', icon: Briefcase },
    { key: 'applications', label: 'My Applications', icon: FileText },
    { key: 'earnings', label: 'Earnings', icon: DollarSign },
    { key: 'engagements', label: 'Engagements', icon: Mic },
    { key: 'calendar', label: 'Calendar', icon: CalendarDays },
    { key: 'availability', label: 'Availability', icon: Clock },
    { key: 'referrals', label: 'Refer + Earn', icon: Users },
    { key: 'help', label: 'Help Center', icon: BookOpen },
  ];
  return (
    <div className="w-full lg:w-56 flex-shrink-0">
      {/* Mobile: compact grid */}
      <div className="lg:hidden mb-4">
        <div className="grid grid-cols-3 sm:grid-cols-5 gap-1">
          {items.map(item => (
            <button key={item.key} onClick={() => setActive(item.key)} data-testid={`dash-nav-${item.key}`}
              className={`flex flex-col items-center gap-1 px-2 py-2.5 text-[10px] font-medium transition-colors ${
                active === item.key ? 'text-[#FF4343] bg-[#FF4343]/10 border border-[#FF4343]/30' : 'text-[#6B7280] bg-[#111827] border border-white/5'
              }`}>
              <item.icon className="w-4 h-4" />
              <span className="leading-tight text-center">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
      {/* Desktop: vertical sidebar */}
      <div className="hidden lg:block space-y-1">
        {items.map(item => (
          <button key={item.key} onClick={() => setActive(item.key)} data-testid={`dash-nav-lg-${item.key}`}
            className={`w-full flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
              active === item.key ? 'text-[#FF4343] bg-[#FF4343]/5 border-l-2 border-[#FF4343]' : 'text-[#9CA3AF] hover:text-white hover:bg-white/5'
            }`}>
            <item.icon className="w-4 h-4" /> {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}
